import FirstComponent from "./FirstComponent";
import SecondComponent from "./SecondComponent";

// "Insurance Solutions We Offer" section (STATIC, code-managed).
function HomeF4() {
    return (
        <>
            <FirstComponent />
            <SecondComponent />
        </>
    );
}

export default HomeF4;
